import { render, staticRenderFns } from "./serviceCompletion.vue?vue&type=template&id=3817f21f&scoped=true"
import script from "./serviceCompletion.vue?vue&type=script&lang=js"
export * from "./serviceCompletion.vue?vue&type=script&lang=js"
import style0 from "./serviceCompletion.vue?vue&type=style&index=0&id=3817f21f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3817f21f",
  null
  
)

export default component.exports